import React, { useContext } from "react";
import MultiSelectDropdown from "../MultiSelectDropdown";

import { UserContext } from "shared/context/UserContext";
export default function MemberPayerDropdown(props) {
  const { onChange, customPayerList = null, disabled = false } = props;
  const userContext = useContext(UserContext);

  return (
    userContext.payers && (
      <MultiSelectDropdown
        options={customPayerList ? customPayerList : userContext.payers}
        onChange={onChange}
        selectAllOption
        filterable
        onLoadAllSelected
        disabled={disabled}
      />
    )
  );
}
